var map = {
	"./abozzi.webp": 8319,
	"./anca.png": 273,
	"./anca.webp": 5987,
	"./angeloni.png": 9925,
	"./angeloni.webp": 9379,
	"./bonelli.png": 1513,
	"./bonelli.webp": 9205,
	"./capello.png": 9378,
	"./capello.webp": 5276,
	"./doni.png": 208,
	"./doni.webp": 7440,
	"./maisano.webp": 8226,
	"./petrova.png": 8299,
	"./petrova.webp": 2467,
	"./polese.png": 3362,
	"./polese.webp": 8314,
	"./zoppi.png": 152,
	"./zoppi.webp": 8822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9580;